module.exports = __webpack_public_path__ + "img/bgtitlebar.82c208cc.png";